import type { ComponentProps } from 'react'
import { Search, X } from 'lucide-react'
import { cn } from '@quebon/ui/lib/utils'

interface AdminSearchInputProps extends Omit<ComponentProps<'input'>, 'type' | 'value' | 'onChange'> {
  value: string
  onValueChange: (value: string) => void
  onClear: () => void
  clearLabel: string
  containerClassName?: string
}

export function AdminSearchInput({
  value,
  onValueChange,
  onClear,
  clearLabel,
  containerClassName,
  ...inputProps
}: AdminSearchInputProps) {
  return (
    <div className={cn('relative min-w-56 max-w-lg flex-1', containerClassName)}>
      <Search
        className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-gray-400"
        aria-hidden
      />
      <input
        {...inputProps}
        type="text"
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
        autoComplete="off"
        className="w-full rounded-lg border border-gray-300 bg-white py-2 pl-9 pr-9 text-sm text-gray-900 outline-none transition focus:border-primary-500 focus:ring-2 focus:ring-primary-100"
      />
      {value.length > 0 ? (
        <button
          type="button"
          onClick={onClear}
          aria-label={clearLabel}
          className="absolute right-2 top-1/2 flex size-6 -translate-y-1/2 items-center justify-center rounded text-gray-400 hover:bg-gray-100 hover:text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-200"
        >
          <X className="size-4" aria-hidden />
        </button>
      ) : null}
    </div>
  )
}
